export default __webpack_public_path__ + "static/favicon-ec55550758f9a9f81ee5e735d4fa8f78.png";